export const globalSpinnerReducerKey = 'globalSpinnerReducer';

export const showGlobalSpinnerType = 'showGlobalSpinnerType';
export const hideGlobalSpinnerType = 'hideGlobalSpinnerType';

export const spinnerTypes = {
  progress: 'progress',
};
